module.exports = __webpack_public_path__ + "static/media/best-execution.c55f7c28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/best-execution.jpg
// module id = 574
// module chunks = 0